import { createClient } from 'laboratory-lib';
import experiments from '../../experiments.yaml';
export const createLaboratoryClient = userId => {
  return createClient({
    name: 'passkey-nudge-experiment-two',
    experiments: experiments,
    identifiers: {
      userId
    }
  });
};